import React from 'react';
function ContactUs({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 15.5V18c0 .333.2 1 1 1h9c.167 0 .6.1 1 .5l1.5 1.5c.167.167.5.4.5 0V10c0-.333-.2-1-1-1h-1.5"
      />
      <path d="M4 3h11a1 1 0 011 1v7.833a1 1 0 01-1 1H5.57a.1.1 0 00-.066.024L3.165 14.86A.1.1 0 013 14.783V4a1 1 0 011-1z" />
      <path strokeLinecap="round" d="M13 6.5H6M13 9.5H6" />
    </svg>
  );
}

export default ContactUs;
